import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Stethoscope icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Stethoscope } from '@sravni/design-system-icons'
 *
 * <Stethoscope />
 * ```
 */
var Stethoscope = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Stethoscope", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.282 9.79a1.964 1.964 0 1 1-2.778 2.778 1.964 1.964 0 0 1 2.778-2.778M5.285 2.929H3.714c-.868 0-1.571.703-1.571 1.571v3.143a4.714 4.714 0 1 0 9.428 0V4.5c0-.868-.703-1.571-1.571-1.571H8.428", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M15.892 13.143v.197a4.518 4.518 0 1 1-9.036 0v-.983M5.285 2.143v1.571M8.428 2.143v1.571", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Stethoscope };
//# sourceMappingURL=Stethoscope.js.map
